// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"98fb5fd6","732":"6d7350e9","977":"a4583668"}[chunkId] + ".chunk.js";
};